var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5146_256903",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 15,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48207 5.87663C3.26382 5.65538 2.90757 5.65238 2.68632 5.87063C2.46582 6.08888 2.46357 6.44513 2.68182 6.66638L8.43432 12.4999C8.68257 12.7519 9.01482 12.8906 9.36882 12.8906C9.72207 12.8906 10.0551 12.7519 10.3033 12.4999L16.0551 6.66638C16.1623 6.55688 16.2163 6.41437 16.2163 6.27112C16.2163 6.12637 16.1601 5.98088 16.0491 5.87063C15.8278 5.65238 15.4716 5.65537 15.2533 5.87662L9.50157 11.7094C9.45432 11.7589 9.39807 11.7656 9.36882 11.7656C9.33957 11.7656 9.28257 11.7589 9.23532 11.7094L3.48207 5.87663Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5146_256903)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.367188,
    y: 0.299805,
    width: 18,
    height: 18,
    fill: "#010101"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/arrow3.a55fb66d2f54b46f5fbda8b8e128df61.svg";
export { ForwardRef as ReactComponent };